export default "__VITE_ASSET__DDa4iOA3__";